import React from 'react';

export default function LandingPage() {
  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        body {
          background: #0a0a0a;
          color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          min-height: 100vh;
        }

        .maintenance-root {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(99,102,241,0.12) 0%, transparent 70%),
                      #0a0a0a;
          text-align: center;
        }

        .logo-wrap {
          margin-bottom: 48px;
        }

        .logo-wrap img {
          height: 48px;
          width: auto;
          opacity: 0.92;
        }

        .badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(99,102,241,0.15);
          border: 1px solid rgba(99,102,241,0.3);
          border-radius: 100px;
          padding: 6px 14px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #a5b4fc;
          margin-bottom: 32px;
        }

        .badge-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #f59e0b;
          box-shadow: 0 0 6px #f59e0b;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0.4; }
        }

        h1 {
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 700;
          line-height: 1.15;
          letter-spacing: -0.02em;
          color: #ffffff;
          margin-bottom: 20px;
        }

        h1 span {
          background: linear-gradient(135deg, #a5b4fc 0%, #818cf8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .sub {
          font-size: 18px;
          line-height: 1.6;
          color: rgba(255,255,255,0.5);
          max-width: 480px;
          margin: 0 auto 48px;
        }

        .divider {
          width: 48px;
          height: 2px;
          background: linear-gradient(90deg, #6366f1, #818cf8);
          border-radius: 2px;
          margin: 0 auto 48px;
        }

        .contact-line {
          font-size: 14px;
          color: rgba(255,255,255,0.35);
        }

        .contact-line a {
          color: #a5b4fc;
          text-decoration: none;
        }

        .contact-line a:hover {
          text-decoration: underline;
        }

        .footer {
          position: fixed;
          bottom: 24px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: rgba(255,255,255,0.2);
        }
      `}</style>

      <div className="maintenance-root">
        <div className="logo-wrap">
          <img src="/cp-logo.png" alt="ClearPath PT" />
        </div>

        <div className="badge">
          <span className="badge-dot" />
          Temporarily Inactive
        </div>

        <h1>
          We'll be back <span>soon.</span>
        </h1>

        <p className="sub">
          ClearPath PT is currently offline for updates. We're working on something better and will be back shortly.
        </p>

        <div className="divider" />

        <p className="contact-line">
          Questions? Reach us at{' '}
          <a href="mailto:ericmoorexc@gmail.com">ericmoorexc@gmail.com</a>
        </p>
      </div>

      <div className="footer">© {new Date().getFullYear()} ClearPath PT. All rights reserved.</div>
    </>
  );
}
